import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material';
export default function NumberSpinnerField(props) {
    const theme = useTheme();
    const [value, setValue] = useState();
    const [canMinus, setCanMinus] = useState(false);
    const [canPlus, setCanPlus] = useState(true);
    useEffect(() => {
        var _a, _b, _c, _d;
        let _value = (_a = props.defaultValue) !== null && _a !== void 0 ? _a : Math.max(1, ((_b = props === null || props === void 0 ? void 0 : props.min) !== null && _b !== void 0 ? _b : 1));
        setCanMinus(_value > ((_c = props === null || props === void 0 ? void 0 : props.min) !== null && _c !== void 0 ? _c : 1));
        setCanPlus(_value < ((_d = props === null || props === void 0 ? void 0 : props.max) !== null && _d !== void 0 ? _d : 99));
        setValue(_value);
    }, [props]);
    const plus = (event) => {
        var _a, _b, _c;
        event.preventDefault();
        if (value && value < ((_a = props === null || props === void 0 ? void 0 : props.max) !== null && _a !== void 0 ? _a : 99)) {
            setValue(value + 1);
            setCanMinus((value + 1) > ((_b = props === null || props === void 0 ? void 0 : props.min) !== null && _b !== void 0 ? _b : 1));
            setCanPlus((value + 1) < ((_c = props === null || props === void 0 ? void 0 : props.max) !== null && _c !== void 0 ? _c : 99));
        }
    };
    const minus = (event) => {
        var _a, _b, _c;
        if (value && value > ((_a = props === null || props === void 0 ? void 0 : props.min) !== null && _a !== void 0 ? _a : 1)) {
            setValue(value - 1);
            setCanMinus((value - 1) > ((_b = props === null || props === void 0 ? void 0 : props.min) !== null && _b !== void 0 ? _b : 1));
            setCanPlus((value - 1) < ((_c = props === null || props === void 0 ? void 0 : props.max) !== null && _c !== void 0 ? _c : 99));
        }
    };
    useEffect(() => {
        if (props.onChange && value) {
            props.onChange(value, props.name.toString());
        }
    }, [value]);
    const onChange = (e) => {
        var _a, _b, _c, _d, _e, _f, _g;
        let newValue = parseInt(e.target.value);
        if (Number.isNaN(newValue))
            newValue = (_a = props === null || props === void 0 ? void 0 : props.min) !== null && _a !== void 0 ? _a : 1;
        if (newValue > ((_b = props === null || props === void 0 ? void 0 : props.max) !== null && _b !== void 0 ? _b : 99))
            newValue = ((_c = props === null || props === void 0 ? void 0 : props.max) !== null && _c !== void 0 ? _c : 99);
        if (newValue < ((_d = props === null || props === void 0 ? void 0 : props.min) !== null && _d !== void 0 ? _d : 1))
            newValue = ((_e = props === null || props === void 0 ? void 0 : props.min) !== null && _e !== void 0 ? _e : 1);
        setCanMinus(newValue > ((_f = props === null || props === void 0 ? void 0 : props.min) !== null && _f !== void 0 ? _f : 1));
        setCanPlus(newValue < ((_g = props === null || props === void 0 ? void 0 : props.max) !== null && _g !== void 0 ? _g : 99));
        setValue(newValue);
    };
    return (_jsx(_Fragment, { children: _jsxs(Box, { sx: {
                display: 'inline-block',
                borderRadius: '4px',
                border: '1px solid rgba(124, 43, 131, 0.5);'
            }, children: [_jsx(Button, { variant: 'outlined', onClick: minus, disabled: !canMinus, sx: {
                        width: '40px',
                        height: '46px',
                        minWidth: 0,
                        border: 'none',
                        borderRadius: "4px 0 0 4px",
                        color: theme.palette.text.primary,
                        "&:focus": {
                            background: theme.palette.background.default,
                            color: theme.palette.primary.main
                        },
                        "&:hover": {
                            background: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            border: 'none'
                        }
                    }, children: "-" }), _jsx(TextField, { onChange: onChange, value: props.defaultValue, sx: {
                        borderWidth: 0,
                        height: '46px',
                        color: theme.palette.text.primary,
                        "& fieldset": {
                            borderWidth: '1px',
                            borderTopWidth: 0,
                            borderBottomWidth: 0,
                            borderRadius: 0
                        },
                        "& > div": {
                            border: 'none',
                            borderRadius: 0
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            backgroundColor: "transparent"
                        }
                    }, inputProps: {
                        inputMode: "numeric",
                        style: {
                            textAlign: 'center',
                            padding: '9px 0px',
                            width: '40px',
                            height: '28px',
                            color: theme.palette.text.primary,
                        }
                    } }), _jsx(Button, { variant: 'outlined', onClick: plus, disabled: !canPlus, sx: {
                        width: '40px',
                        height: '46px',
                        minWidth: 0,
                        border: 'none',
                        borderRadius: "0 4px 4px 0",
                        color: theme.palette.text.primary,
                        "&:focus": {
                            background: theme.palette.background.default,
                            color: theme.palette.primary.main
                        },
                        "&:hover": {
                            background: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            border: 'none'
                        }
                    }, children: "+" })] }) }));
}
